/* NAL's Closet — quick add-to-bag from product cards (GA-style "+").
   Vanilla JS with event delegation: works in every grid that renders
   the nc-product-card snippet, including content loaded later. */
(function () {
  'use strict';

  var ADD_URL = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

  /* ── open / close ──────────────────────────────────────────── */

  function collapse(qa) {
    qa.classList.remove('is-open');
    var toggle = qa.querySelector('.nc-qa__toggle');
    var strip = qa.querySelector('.nc-qa__strip');
    if (toggle) {
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
    }
    if (strip) strip.hidden = true;
  }

  function closeAll(except) {
    document.querySelectorAll('[data-nc-qa].is-open').forEach(function (qa) {
      if (qa !== except) collapse(qa);
    });
  }

  function expand(qa) {
    closeAll(qa);
    qa.classList.add('is-open');
    var toggle = qa.querySelector('.nc-qa__toggle');
    var strip = qa.querySelector('.nc-qa__strip');
    if (toggle) {
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'true');
    }
    if (strip) strip.hidden = false;
  }

  /* ── header cart badge ─────────────────────────────────────── */

  function bumpCartCount(count) {
    var link = document.querySelector('a.nc-header__icon-btn[href*="/cart"]');
    if (!link) return;
    var badge = link.querySelector('.nc-cart-count');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'nc-cart-count';
      badge.setAttribute('aria-hidden', 'true');
      link.appendChild(badge);
    }
    badge.textContent = count;
    badge.classList.remove('nc-qa-pulse');
    void badge.offsetWidth; /* restart the pulse animation */
    badge.classList.add('nc-qa-pulse');
    link.setAttribute('aria-label', 'Cart (' + count + ' items)');
  }

  /* ── add to cart ───────────────────────────────────────────── */

  function showDone(qa) {
    var strip = qa.querySelector('.nc-qa__strip');
    if (!strip) return;
    var original = strip.innerHTML;
    strip.innerHTML = '<span class="nc-qa__done">Added to Bag ✓</span>';
    window.setTimeout(function () {
      strip.innerHTML = original;
      collapse(qa);
    }, 1400);
  }

  function addVariant(qa, btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            throw new Error((data && (data.description || data.message)) || 'Could not add to bag');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        bumpCartCount(cart.item_count);
        showDone(qa);
      })
      .catch(function (err) {
        window.alert(err.message || 'Could not add to bag. Please try again.');
        collapse(qa);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  }

  /* ── delegated events ──────────────────────────────────────── */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.nc-qa__toggle');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      expand(toggle.closest('[data-nc-qa]'));
      return;
    }

    var size = e.target.closest('.nc-qa__size');
    if (size) {
      e.preventDefault();
      e.stopPropagation();
      addVariant(size.closest('[data-nc-qa]'), size);
      return;
    }

    /* click anywhere else closes any open strip */
    if (!e.target.closest('[data-nc-qa]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
